export const GET_HARDWARE_INCLUSIVE_STOCK_COUNTER_INIT = 'GET_HARDWARE_INCLUSIVE_STOCK_COUNTER_INIT';
export const GET_HARDWARE_INCLUSIVE_COUNTER_SUCCESS = 'GET_HARDWARE_INCLUSIVE_COUNTER_SUCCESS';
export const GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE = 'GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE';
export const GET_HARDWARE_INCLUSIVE_COUNTER_RESET = 'GET_HARDWARE_INCLUSIVE_COUNTER_RESET';


export const UPDATE_HARDWARE_INCLUSIVE_COUNTER_INIT = 'UPDATE_HARDWARE_INCLUSIVE_COUNTER_INIT';
export const UPDATE_HARDWARE_INCLUSIVE_COUNTER_SUCCESS = 'UPDATE_HARDWARE_INCLUSIVE_COUNTER_SUCCESS';
export const UPDATE_HARDWARE_INCLUSIVE_COUNTER_FAILURE = 'UPDATE_HARDWARE_INCLUSIVE_COUNTER_FAILURE';
export const UPDATE_HARDWARE_INCLUSIVE_COUNTER_RESET = 'UPDATE_HARDWARE_INCLUSIVE_COUNTER_RESET';

export const ADD_HARDWARE_INCLUSIVE_COUNTER_INIT = 'ADD_HARDWARE_INCLUSIVE_COUNTER_INIT';
export const ADD_HARDWARE_INCLUSIVE_COUNTER_SUCCESS = 'ADD_HARDWARE_INCLUSIVE_COUNTER_SUCCESS';
export const ADD_HARDWARE_INCLUSIVE_COUNTER_FAILURE = 'ADD_HARDWARE_INCLUSIVE_COUNTER_FAILURE';
export const ADD_HARDWARE_INCLUSIVE_COUNTER_RESET = 'ADD_HARDWARE_INCLUSIVE_COUNTER_RESET';